/**
 * Speing Journal - Table of Contents & Social Share Helper
 * Pure Vanilla JavaScript (<2KB), high performance, zero external dependencies.
 */
document.addEventListener('DOMContentLoaded', function () {
  initTableOfContents();
  initCopyLinkToast();
});

function initTableOfContents() {
  const contentArea = document.querySelector('.article-page__content') || document.querySelector('.article-template__content');
  const desktopTocContainer = document.querySelector('#article-toc-list');
  const mobileTocContainer = document.querySelector('#article-toc-mobile-list');

  if (!contentArea) return;

  const headings = contentArea.querySelectorAll('h2, h3');
  if (headings.length < 2) {
    // If fewer than 2 headings, hide the TOC widgets if they exist
    const tocSidebars = document.querySelectorAll('.article-toc, .article-toc-mobile');
    tocSidebars.forEach(el => el.style.display = 'none');
    return;
  }

  headings.forEach((heading, index) => {
    let id = heading.getAttribute('id');
    if (!id) {
      id = 'heading-' + index + '-' + heading.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
      heading.setAttribute('id', id);
    }

    const text = heading.textContent.trim();
    const isH3 = heading.tagName.toLowerCase() === 'h3';

    if (desktopTocContainer) {
      const li = document.createElement('li');
      li.className = 'article-toc__item' + (isH3 ? ' article-toc__item--h3' : '');
      const a = document.createElement('a');
      a.href = '#' + id;
      a.className = 'article-toc__link';
      a.textContent = text;
      a.setAttribute('data-target-id', id);
      li.appendChild(a);
      desktopTocContainer.appendChild(li);
    }

    if (mobileTocContainer) {
      const li = document.createElement('li');
      li.className = 'article-toc__item' + (isH3 ? ' article-toc__item--h3' : '');
      const a = document.createElement('a');
      a.href = '#' + id;
      a.className = 'article-toc__link';
      a.textContent = text;
      a.setAttribute('data-target-id', id);
      a.addEventListener('click', () => {
        const details = mobileTocContainer.closest('details');
        if (details) details.removeAttribute('open');
      });
      li.appendChild(a);
      mobileTocContainer.appendChild(li);
    }
  });

  // ScrollSpy for desktop TOC
  if (desktopTocContainer && 'IntersectionObserver' in window) {
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -60% 0px',
      threshold: 0
    };

    const links = desktopTocContainer.querySelectorAll('.article-toc__link');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const activeId = entry.target.getAttribute('id');
          links.forEach((link) => {
            if (link.getAttribute('data-target-id') === activeId) {
              link.classList.add('article-toc__link--active');
            } else {
              link.classList.remove('article-toc__link--active');
            }
          });
        }
      });
    }, observerOptions);

    headings.forEach((h) => observer.observe(h));
  }
}

function initCopyLinkToast() {
  document.querySelectorAll('.js-copy-article-link').forEach((btn) => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const url = this.getAttribute('data-url') || window.location.href;
      
      navigator.clipboard.writeText(url).then(() => {
        let toast = document.getElementById('speing-share-toast');
        if (!toast) {
          toast = document.createElement('div');
          toast.id = 'speing-share-toast';
          toast.className = 'article-share__toast';
          toast.textContent = 'Link copied to clipboard!';
          document.body.appendChild(toast);
        }
        toast.style.display = 'block';
        setTimeout(() => {
          toast.style.display = 'none';
        }, 2500);
      }).catch(err => {
        console.error('Could not copy link:', err);
      });
    });
  });
}
